import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "relative w-full flex flex-col place-items-center gap-4"
}

interface Props {
  submitted: boolean;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ContactMeForm',
  props: {
    submitted: { type: Boolean }
  },
  emits: ['toggle-submitted'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const submitForm = (): void => {
  setTimeout(() => {
    const formElement = document.getElementById('form-group') as HTMLFormElement;
    if (formElement) {
      formElement.reset(); 
    }
    emit('toggle-submitted', true);
  }, 500); 
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.submitted)
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          target: "_blank",
          action: "https://formspree.io/f/xeoopyvb",
          method: "POST",
          id: "form-group",
          class: "flex flex-col gap-2 justify-center",
          onSubmit: submitForm
        }, _cache[1] || (_cache[1] = [
          _createStaticVNode("<div class=\"form-group\" data-v-7c46b7e4><div class=\"form-row\" data-v-7c46b7e4><div class=\"col flex flex-col gap-2\" data-v-7c46b7e4><label for=\"name\" id=\"name\" class=\"text-[#6a998f] text-lg m-0 leading-none\" data-v-7c46b7e4>Full Name:</label><input type=\"text\" name=\"name\" class=\"form-control\" placeholder=\"Full Name\" required data-v-7c46b7e4></div></div></div><div class=\"form-group\" data-v-7c46b7e4><div class=\"col\" data-v-7c46b7e4><label for=\"email\" id=\"email\" class=\"text-[#6a998f] text-lg mb-0 leading-none\" data-v-7c46b7e4>Email:</label><input type=\"email\" name=\"email\" class=\"form-control\" placeholder=\"Email Address\" required data-v-7c46b7e4></div></div><div class=\"form-group\" data-v-7c46b7e4><label for=\"message\" id=\"message\" class=\"text-[#6a998f] text-lg mb-0 leading-none\" data-v-7c46b7e4>Your Message:</label><textarea placeholder=\"Your Message\" class=\"form-control resize-none\" name=\"message\" rows=\"5\" required data-v-7c46b7e4></textarea></div><div class=\"flex flex-row items-start gap-4\" data-v-7c46b7e4><button type=\"submit\" class=\"w-auto whitespace-nowrap\" data-v-7c46b7e4>Submit Form</button><button type=\"reset\" class=\"w-auto whitespace-nowrap\" data-v-7c46b7e4>Reset Form</button></div>", 4)
        ]), 32))
      : _createCommentVNode("", true),
    (_ctx.submitted)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "block font-normal text-lg" }, "Thanks for sending your message!", -1)),
          _cache[3] || (_cache[3] = _createElementVNode("span", { class: "block font-normal text-lg" }, "I will respond as soon as possible", -1)),
          _createElementVNode("button", {
            class: "w-auto whitespace-nowrap",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('toggle-submitted')))
          }, " Send Another Message ")
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})